export function get3DomainName(): string {
  const url = useRequestURL()

  if (
    ['localhost', '127.0.0.1', ':3020', '::1', '[::1]'].includes(url.hostname)
    || url.origin.includes(':3020')
    || url.origin.includes(':3030')
  ) {
    return String(useRuntimeConfig().public.DEFAULT_DOMAIN || '')
  }

  const domainNames = url.hostname.split('.').reverse()

  return domainNames[Math.min(domainNames.length - 1, 2)] || ''
}
